module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba_funabashi_point3_5-edbdeac3a7ce38bc2fdb043251fe2683.jpg";